import { SupportedLocale } from '@amzn/red-velvet-api';

export type SupportedLanguage = {
  locale: SupportedLocale;
  /** Written in the language itself, so speakers can find their own entry. */
  label: string;
};

/**
 * The languages the picker offers, in the order they appear in the dropdown.
 */
export const P0_SUPPORTED_LANGUAGES: readonly SupportedLanguage[] = [
  { locale: SupportedLocale.CS_CZ, label: 'Čeština (Česko)' },
  { locale: SupportedLocale.DE_DE, label: 'Deutsch (Deutschland)' },
  { locale: SupportedLocale.EN_US, label: 'English (United States)' },
  { locale: SupportedLocale.ES_ES, label: 'Español (España)' },
  { locale: SupportedLocale.ES_US, label: 'Español (Estados Unidos)' },
  { locale: SupportedLocale.ES_MX, label: 'Español (México)' },
  { locale: SupportedLocale.FR_BE, label: 'Français (Belgique)' },
  { locale: SupportedLocale.FR_CA, label: 'Français (Canada)' },
  { locale: SupportedLocale.FR_FR, label: 'Français (France)' },
  { locale: SupportedLocale.IT_IT, label: 'Italiano (Italia)' },
  { locale: SupportedLocale.PL_PL, label: 'Polski (Polska)' },
  { locale: SupportedLocale.PT_BR, label: 'Português (Brasil)' },
  { locale: SupportedLocale.PT_PT, label: 'Português (Portugal)' },
  { locale: SupportedLocale.JA_JP, label: '日本語 (日本)' },
];

/** Shown when nothing else identifies the user's language. */
export const DEFAULT_LOCALE: SupportedLocale = SupportedLocale.EN_US;

/**
 * Which variant a user gets when their browser asks for a language without a country, such as `fr`.
 *
 * Set here on purpose so reordering the list above cannot change the language anyone is served.
 */
export const DEFAULT_LOCALE_BY_LANGUAGE: Readonly<Record<string, SupportedLocale>> = {
  cs: SupportedLocale.CS_CZ,
  de: SupportedLocale.DE_DE,
  en: SupportedLocale.EN_US,
  es: SupportedLocale.ES_ES,
  fr: SupportedLocale.FR_FR,
  it: SupportedLocale.IT_IT,
  ja: SupportedLocale.JA_JP,
  pl: SupportedLocale.PL_PL,
  pt: SupportedLocale.PT_BR,
};
